<template>
  <div>
    <CRow>
      <CCol md="12">
        <div style="float: right; text-align: right;" class="d-none d-sm-block">
          <h2 style="font-size: 1.5rem">Vigencia: {{ challenge.end_date | date }}</h2>
          <h5 v-if="challenge.type != 'boxes_and_customers' && challenge.type != 'objectives'"
            style="font-size: 1.0rem; font-weight: bold;">{{ challenge.complete ? 'COMPLETADO' : 'NO COMPLETADO' }}</h5>
        </div>
        <br />
        <h1 v-if="challenge.type != 'boxes'"
          style="font-size: 1.2rem; margin: auto; text-align: center; width: 100%; max-width: 400px;">
          {{ challenge.name }}
        </h1>
        <br />
        <h5 style="font-size: 1.0rem; margin: auto; text-align: center; width: 100%; max-width: 400px;"
          v-if="!challenge.complete">{{ challenge.description }}</h5>
        <h5 style="font-size: 1.0rem; margin: auto; text-align: center; width: 100%; max-width: 400px;"
          v-if="challenge.awards != undefined && challenge.awards.length == 1">
          <br /><br /><b>{{ awardLabel }}</b>
          <br v-if="challenge.provider_id > 0" />
          <b>{{ challenge.provider_id > 0 ? "" + challenge.provider_name : '' }}</b>
          <br /><br />
          {{ challenge.awards[0].description }}
        </h5>

        <div v-if="challenge.type != 'boxes_and_customers' && challenge.type != 'objectives'">
          <div style="font-size: 10px; color: red; text-align: center; width: 100%" v-if="!challenge.enabled && false">
            <br />NO HAY PREMIOS DISPONIBLES
          </div>
          <div style="font-size: 14px; color: red; text-align: center; width: 100%"
            v-if="(challenge.enabled && challenge.quantity > 0)"><br />Premios Disponibles: {{ challenge.quantity > 0 ?
              challenge.quantity : 0 }}</div>
          <br /><br />
          <h3 style="font-size: 12px; text-align: center;" v-if="challenge.complete"><br /><br />Has completado este
            concurso<br /><br /></h3>
        </div>
        <!-- Video -->
        <CRow v-if="challenge.type == 'video'">
          <CCol md="12" style="text-align: center;">
            <div v-show="video.quest == false">
              <CButton color="info" size="sm" v-for="(video, index) in challenge.videos" :key="index"
                style="margin-right: 5px;" @click="changeVideo(video.youtube_reference)">Video {{ index + 1 }}</CButton>
              <br /><br />
              <div v-show="challenge.videos.length > 0" id="video-player-container" style="text-align: center;">
                <div v-if="video.quest == false" id="video-player-large" style="width:600px; margin: auto;"
                  class="d-none d-xxl-block d-xl-block d-lg-block d-md-block"></div>
                <div v-if="video.quest == false" id="video-player-small" style="width:100%"
                  class="d-xl-none d-xxl-none d-lg-none d-md-none"></div>
              </div>
              <div class="text-center">
                <img :src="challenge.image_filename" alt="" style="width:600px; margin: auto;"
                  class="d-none d-xxl-block d-xl-block d-lg-block d-md-block">
              </div>
              <br /><br />
              <CButton v-if="!challenge.complete" color="info" size="lg" style="margin-right: 5px;"
                @click="initQuest()">{{ challenge.text_button }}</CButton>
              <br /><br /><br />
            </div>
            <div v-if="video.quest == true" style="text-align: left;">
              <CRow v-if="challenge.type == 'video'">
                <CCol md="12">
                  <div v-for="(question, q) in video.questions">
                    <strong>{{ question.question }}</strong><br /><br />
                    <div v-if="question.type == 'options'" v-for="(option, o) in question.options.split(',')">
                      <input type="radio" :name="'question_' + question.id" @click="setAnswer(q, o, option)"
                        style="margin: 10px;"> {{ option }}
                    </div>
                    <div v-if="question.type == 'text'">
                      <input type="text" :name="'question_' + question.id" v-model="video.questions[q].supplier_answer"
                        style="margin: 0px; width: 100%;">
                    </div>
                    <div v-if="question.type == 'file' || question.type == 'multipleFile'">
                      <CButton color="info" size="sm" @click="uploadModal(challenge, question, q)"
                        style="margin-right: 10px;">Cargar Archivo</CButton>
                    </div>
                    <br />
                  </div>
                  <div v-if="files.length > 0" style="margin-top: 20px;">
                    <CDataTable hover striped border small fixed :items="files" :fields="fields" pagination>
                      <template #file="{ item }">
                        <td class="w100 text-center">
                          {{ item.question }}
                          <br />
                          <a :href="item.file" target="_blank">{{ item.file_name }}</a>
                        </td>
                      </template>
                      <template #actions="{ item }">
                        <td class="table_actions b3">
                          <CButton color="danger" size="sm" @click="deleteModal(item)">
                            <CIcon name="cil-trash" />
                          </CButton>
                        </td>
                      </template>
                    </CDataTable>
                  </div>
                  <div style="text-align: center;">
                    <br /><br />
                    <CButton color="info" size="lg" style="margin: auto;" @click="finishQuest()">Enviar</CButton>
                    <br /><br />
                  </div>
                </CCol>
              </CRow>
            </div>
          </CCol>
        </CRow>
        <!-- Cajas -->
        <CRow v-if="challenge.type == 'boxes'">
          <CCol md="12" style="text-align: center;" v-if="challenge.mechanic == 'total'">
            <div style="font-size: 14px; text-align: center; width: 100%; font-weight: bold;" v-if="progress.won > 0">
              {{ progress.won }}<br />Puntos Ganados<br /><br /></div>
            <CProgress :value="progress.rate"
              style="border: 1px solid; height: 50px; width: 100%; text-align: center;" />
            <div style="font-size: 12px; text-align: center; width: 100%;"><br />{{ progress.sold }} de
              {{ progress.goal }}<br />Cajas Vendidas</div>
          </CCol>
          <CCol md="12" style="text-align: center;" v-if="challenge.mechanic == 'individual'">
            <div style="font-size: 14px; text-align: center; width: 100%; font-weight: bold;" v-if="progress.won > 0">
              {{ progress.won }}<br />Puntos Ganados<br /><br /></div>
            <div style="font-size: 14px; text-align: center; width: 100%; font-weight: bold;" v-else>
              {{ challenge.entry.points }}<br />Puntos Ganados<br /><br /></div>
          </CCol>
          <CCol md="12" style="text-align: center;" v-if="challenge.mechanic == 'ranges'">
            <div style="font-size: 14px; text-align: center; width: 100%; font-weight: bold;" v-if="progress.won > 0">
              {{ progress.won }}<br />Puntos Ganados<br /><br /></div>
            <CProgress :value="progress.rate"
              style="border: 1px solid; height: 50px; width: 100%; text-align: center;" />
            <div style="font-size: 14px; text-align: center; width: 100%;"><br />{{ progress.sold > 0 ? progress.sold %
              progress.goal : 0 }}<span v-if="!progress.completed"> de {{ progress.goal }}</span><br />Cajas Vendidas
            </div>
            <div style="font-size: 14px; text-align: center; width: 100%;">
              <br />Rangos de Ventas<br /><br />
              <table style="width: 100%;">
                <tr>
                  <th style="border: 1px solid;">Cajas</th>
                  <th style="border: 1px solid;">Puntos</th>
                </tr>
                <tr v-for="(range, index) in progress.ranges" :key="'r_' + index">
                  <td style="border: 1px solid;">{{ range.min }}<span v-if="range.max < 999999"> -
                      {{ range.max }}</span><span v-if="range.max >= 999999">+</span></td>
                  <td style="border: 1px solid;">{{ range.award }}</td>
                </tr>
              </table>
            </div>
          </CCol>
        </CRow>
        <!-- Clientes -->
        <CRow v-if="challenge.type == 'customers'">
          <CCol md="12" style="text-align: center;" v-if="challenge.mechanic == 'total'">
            <div style="font-size: 14px; text-align: center; width: 100%; font-weight: bold;" v-if="progress.won > 0">
              {{ progress.won }}<br />Puntos Ganados<br /><br /></div>
            <CProgress :value="progress.rate"
              style="border: 1px solid; height: 50px; width: 100%; text-align: center;" />
            <div style="font-size: 12px; text-align: center; width: 100%;"><br />{{ progress.sold }} de
              {{ progress.goal }}<br />Cajas Vendidas</div>
          </CCol>
          <CCol md="12" style="text-align: center;" v-if="challenge.mechanic == 'individual'">
            <div style="font-size: 14px; text-align: center; width: 100%; font-weight: bold;" v-if="progress.won > 0">
              {{ progress.won }}<br />Puntos Ganados<br /><br /></div>
            <div style="font-size: 14px; text-align: center; width: 100%; font-weight: bold;" v-else>
              {{ challenge.entry.points }}<br />Puntos Ganados<br /><br /></div>
          </CCol>
          <CCol md="12" style="text-align: center;" v-if="challenge.mechanic == 'ranges'">
            <div style="font-size: 14px; text-align: center; width: 100%; font-weight: bold;" v-if="progress.won > 0">
              {{ progress.won }}<br />Puntos Ganados<br /><br /></div>
            <CProgress :value="progress.rate"
              style="border: 1px solid; height: 50px; width: 100%; text-align: center;" />
            <div style="font-size: 14px; text-align: center; width: 100%;"><br />{{ progress.sold > 0 ? progress.sold %
              progress.goal : 0 }}<span v-if="!progress.completed"> de {{ progress.goal }}</span><br />Cajas Vendidas
            </div>
            <div style="font-size: 14px; text-align: center; width: 100%;">
              <br />Rangos de Ventas<br /><br />
              <table style="width: 100%;">
                <tr>
                  <th style="border: 1px solid;">Cajas</th>
                  <th style="border: 1px solid;">Puntos</th>
                </tr>
                <tr v-for="(range, index) in progress.ranges" :key="'r_' + index">
                  <td style="border: 1px solid;">{{ range.min }}<span v-if="range.max < 999999"> -
                      {{ range.max }}</span><span v-if="range.max >= 999999">+</span></td>
                  <td style="border: 1px solid;">{{ range.award }}</td>
                </tr>
              </table>
            </div>
          </CCol>
        </CRow>
        <!-- Objetivos -->
        <CRow v-if="challenge.type == 'objectives'" style="margin-top: 30px;">
          <CCol md="12" v-for="(rule, index) in challenge.rules" :key="`rule_${rule.id}`"
            style="text-align: center; margin-bottom: 30px;">
            <h5 style="font-weight: bold;">{{ rule.name }}</h5>
            <p>{{ rule.description }}</p>
            <div style="font-size: 14px; font-weight: bold;" v-if="rule.progress.award > 0">
              {{ rule.progress.award }}<br />{{ awardLabelPoints(rule.award_type) }}<br /><br />
            </div>
            <CProgress :value="rule.progress.rate"
              style="border: 1px solid; height: 30px; width: 100%; text-align: center;" />
            <div style="font-size: 12px; text-align: center; width: 100%; margin-top: 10px;">
              {{ rule.progress.sold }} de {{ rule.progress.goal }}
              <span v-if="rule.type == 'sales'"> en Ventas</span>
              <span v-if="rule.type == 'boxes'"> Cajas</span>
              <span v-if="rule.type == 'customers'"> Clientes</span>
            </div>
            <div v-if="rule.progress.completed" style="color: green; font-weight: bold; margin-top: 10px;">
              ¡Objetivo completado!
            </div>
          </CCol>
        </CRow>

        <!-- Cajas y Clientes -->
        <CRow v-if="challenge.type == 'boxes_and_customers'">
          <CCol sm="12" style="text-align: center;">
            <div style="font-size: 14px; text-align: center; width: 100%; font-weight: bold;">Total {{ challenge.alias
            }}
              Marcados<br />{{ challenge.boxes_points * 1 + challenge.customer_points * 1 }}<br /><br /></div>
          </CCol>
          <CCol sm="12" style="text-align: center;">
            <table style="width: 100%">
              <tr>
                <td>
                  <div style="font-size: 14px; text-align: center; width: 100%; font-weight: bold;">
                    {{ challenge.boxes_points }}<br />{{ challenge.alias }} por Cajas<br /><br /></div>
                </td>
                <td>
                  <div style="font-size: 14px; text-align: center; width: 100%; font-weight: bold;">
                    {{ challenge.customer_points }}<br />{{ challenge.alias }} por Clientes<br /><br /></div>
                </td>
              </tr>
            </table>
            <br />
            <div style="font-size: 14px; text-align: center; width: 100%;">
              <br />Ranking de Participantes<br /><br />
              <table style="width: 100%;" v-if="top.length > 0">
                <tr>
                  <th style="font-size: 11px; border: 1px solid; width: 10px; padding: 5px;">#</th>
                  <th style="font-size: 11px; border: 1px solid; width: 10px; padding: 5px;">Ruta</th>
                  <th style="font-size: 11px; border: 1px solid;">Nombre</th>
                  <th style="font-size: 11px; border: 1px solid; width: 10px; padding: 5px;">{{ challenge.alias }}</th>
                </tr>
                <tr v-for="(rank, index) in paginatedTop" :key="'rank_' + index"
                  :style="rank.supplier_id == challenge.entry.supplier_id ? 'font-weight: bold; background-color: #CCC;' : ''">
                  <td style="font-size: 10px; border: 1px solid;">{{ (currentPage - 1) * perPage + index + 1 }}</td>
                  <td style="font-size: 10px; border: 1px solid; text-align: center; padding: 5px;">
                    <span>{{ rank.supplier_code }}</span>
                  </td>
                  <td style="font-size: 10px; border: 1px solid; text-align: left; padding: 5px;">
                    <span>{{ rank.supplier_name }}</span>
                  </td>
                  <td style="font-size: 10px; border: 1px solid;">{{ rank.points }}</td>
                </tr>
                <tr v-if="showMyRankRow" style="font-weight: bold; background-color: #CCC;">
                  <td style="font-size: 10px; border: 1px solid;">??</td>
                  <td style="font-size: 10px; border: 1px solid; text-align: center; padding: 5px;">
                    <span v-if="challenge.supplier && challenge.supplier.code">{{ challenge.supplier.code }}</span>
                    <span v-else>-</span>
                  </td>
                  <td style="font-size: 10px; border: 1px solid; text-align: left; padding: 5px;">
                    <span v-if="challenge.supplier && challenge.supplier.name">
                      {{ challenge.supplier.name }}
                    </span>
                    <span v-else>
                      -
                    </span>
                  </td>
                  <td style="font-size: 10px; border: 1px solid;">{{ challenge.entry.points }}</td>
                </tr>
              </table>
              <div v-if="top.length == 0" style="font-size: 14px; text-align: center; width: 100%; font-weight: bold;">
                Aún no
                hay participantes en este concurso.</div>
              <div v-if="totalPages > 1" style="margin-top: 10px; text-align: center;">
                <button @click="currentPage--" :disabled="currentPage === 1" style="margin-right: 10px;">
                  Anterior
                </button>

                <span style="font-size: 12px;">
                  Página {{ currentPage }} de {{ totalPages }}
                </span>

                <button @click="currentPage++" :disabled="currentPage === totalPages" style="margin-left: 10px;">
                  Siguiente
                </button>
              </div>

            </div>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
    <FileUpload ref="uploadModal" @upload="upload"></FileUpload>
  </div>
</template>
<script>

import store from '../../../store'
import challenges_ws from '../../../services/challenges';
import DeleteModal from '../../../components/global/DeleteModal.vue'
import FileUpload from './FileUpload.vue'
import YouTubePlayer from 'youtube-player';

export default {
  name: 'ChallengeView',
  components: {
    FileUpload,
    DeleteModal
  },
  props: {
    fields: {
      type: Array,
      default() {
        return [
          { key: 'file', label: 'Archivo' },
          { key: 'actions', label: 'Acciones', class: 'actions' },
        ]
      }
    },
  },
  data() {
    return {
      challenge_id: 0,
      challenge: {
        'type': 'boxes'
      },
      player: false,
      screen: "normal",
      video: {
        player_1: false,
        player_2: false,
        quest: false,
        completed: false,
        questions: [],
        rate: 100
      },
      currentPage: 1,
      perPage: 15,
      files: [],
      progress: false,
      top: [],
      fileToDelete: '',
      AWARD_LABELS: {
        cash: 'DINERO EN EFECTIVO',
        ticket: 'BOLETO PARA EVENTO',
        wallet: 'MONEDERO ELECTRÓNICO',
        gift: 'PREMIO',
        card: 'TARJETA DE REGALO',
        event_points: 'PUNTOS PARA EVENTOS',
        card_points: 'PUNTOS PARA CERTIFICADOS',
        gift_points: 'PUNTOS PARA PREMIOS',
        wallet_points: 'PUNTOS PARA MONEDERO',
        digital_points: 'PUNTOS DIGITALES'
      }
    }
  },
  computed: {
    awardLabel() {
      const a = this.challenge?.awards?.[0]
      return a ? (this.AWARD_LABELS[a.type] || '') : ''
    },
    myRankIndex() {
      if (!this.challenge?.entry || !this.top?.length) return -1;
      return this.top.findIndex(
        r => r.supplier_id === this.challenge.entry.supplier_id
      );
    },

    showMyRankRow() {
      // Mostrar SOLO si NO está en el top completo
      return (
        this.challenge &&
        this.challenge.entry &&
        this.challenge.entry.supplier_id &&
        this.myRankIndex === -1
      );
    },

    totalPages() {
      return Math.ceil(this.top.length / this.perPage);
    },

    paginatedTop() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.top.slice(start, start + this.perPage);
    }
  },
  mounted: async function () {
    if (window.screen.width <= 768) {
      this.screen = "mobile";
    }

    let challenge_id = this.$route.params.challenge_id;
    this.challenge_id = challenge_id;

    let response = await challenges_ws.show(this.challenge_id);
    if (response.type == "success") {
      this.challenge = response.data;

      if (this.challenge.type == "video" && this.challenge.videos.length > 0) {
        let _this = this;
        this.video.rate = this.challenge.videos[0].rate;
        setTimeout(function () {
          _this.video.player_1 = YouTubePlayer('video-player-large');
          _this.video.player_1.loadVideoById(_this.challenge.videos[0].youtube_reference);
          _this.video.player_1.stopVideo();
        }, 100);

        setTimeout(function () {
          _this.video.player_2 = YouTubePlayer('video-player-small');
          _this.video.player_2.loadVideoById(_this.challenge.videos[0].youtube_reference);
          _this.video.player_2.stopVideo();
        }, 100);
      }

      if (this.challenge.type == 'boxes') {
        let response2 = await challenges_ws.getProgress(this.challenge_id);
        if (response2.type == "success") {
          this.progress = response2.data;
        }
      }

      if (this.challenge.type == "boxes_and_customers") {
        let response_entries = await challenges_ws.getTopEntries(this.challenge_id);
        if (response_entries.type == "success") {
          this.top = response_entries.data;
        }
      }
    }
  },
  methods: {
    deleteModal(item) {
      this.fileToDelete = item.file;
      this.$refs.deleteModal.show("Eliminar Archivo", item.id, item.name);
    },
    awardLabelPoints(award_type) {
      return award_type ? (this.AWARD_LABELS[award_type] || '') : ''
    },
    async deleteProcess() {
      this.loading();
      const url = this.fileToDelete;
      let response = await challenges_ws.deleteFileQuestion({ url: url });

      if (response.type == "success") {
        const deleted = this.files.find(item => item.file === url);
        // Eliminar del array
        this.files = this.files.filter(item => item.file !== url);
        this.fileToDelete = '';

        if (deleted) {
          const relatedFiles = this.files.filter(f => f.question_id === deleted.question_id);
          const questionIndex = this.video.questions.findIndex(q => q.id === deleted.question_id);

          if (questionIndex !== -1) {
            this.video.questions[questionIndex].supplier_answer = relatedFiles
              .map(f => f.file)
              .join(',');
          }
        }
      }

      this.showToast(response.type, response.message);
      this.loaded();
    },
    changeVideo(youtube) {
      this.video.player_1.loadVideoById(youtube);
      this.video.player_1.stopVideo();

      this.video.player_2.loadVideoById(youtube);
      this.video.player_2.stopVideo();
    },
    async initQuest() {
      this.video.quest = true;

      document.getElementById("video-player-large").remove();
      document.getElementById("video-player-small").remove();

      let response = await challenges_ws.getQuestions(this.challenge_id);
      if (response.type == "success") {
        this.video.questions = response.data;
      }
    },
    async setAnswer(q, o, answer) {
      let options = this.video.questions[q].options.split(",");
      this.video.questions[q].supplier_answer = options[o];
    },
    async finishQuest() {
      let params = {
        challenge_id: this.challenge_id,
        questions: this.video.questions,
      }

      let response = await challenges_ws.saveAnswers(params);
      if (response.type == "success") {
        this.video.quest = false;
        this.video.completed = true;
        this.challenge.complete = true;

        let _this = this;

        if (this.screen == "normal") {
          let div1 = document.createElement("div");
          div1.id = "video-player-large";
          div1.style.width = "600px";
          div1.class = "d-none d-xxl-block d-xl-block d-lg-block d-md-block"

          document.getElementById("video-player-container").appendChild(div1);

          setTimeout(function () {
            _this.video.player_1 = YouTubePlayer('video-player-large');
            _this.video.player_1.loadVideoById(_this.challenge.videos[0].youtube_reference);
            _this.video.player_1.stopVideo();
          }, 100);
        }
        else {
          let div2 = document.createElement("div");
          div2.id = "video-player-small";
          div2.style.width = "100%";
          div2.class = "d-xl-none d-xxl-none d-lg-none d-md-none"

          document.getElementById("video-player-container").appendChild(div2);

          setTimeout(function () {
            _this.video.player_2 = YouTubePlayer('video-player-small');
            _this.video.player_2.loadVideoById(_this.challenge.videos[0].youtube_reference);
            _this.video.player_2.stopVideo();
          }, 100);
        }
      }

      this.showToast(response.type, response.message);
    },
    uploadModal(challenge, question, index) {
      question.index = index;
      this.$refs.uploadModal.show("Cargar Archivo", challenge, question);
    },
    async upload(challenge, question, s3_file) {
      if (question.type == 'file') {
        this.video.questions[question.index].supplier_answer = s3_file;
      } else if (question.type == 'multipleFile') {
        const relatedFiles = this.files.filter(f => f.question_id === question.id);
        this.files.push({
          question_id: question.id,
          question: question.question,
          file: s3_file,
          file_name: `Archivo ${relatedFiles.length + 1}`  // Nombra como Archivo 1, 2, etc. por pregunta
        });
        // Recolectar todos los archivos para esta pregunta
        this.video.questions[question.index].supplier_answer = [...relatedFiles.map(f => f.file), s3_file].join(',');
      }
    },
    async finished() {
      this.loading();

      this.loaded();
    },
    showToast(type, message) {
      store.commit('toast', { color: type, message: message });
    },
    loading() {
      store.commit('loading');
    },
    loaded() {
      store.commit('loaded');
    }
  },
  watch: {
    top() {
      this.currentPage = 1;
    }
  }

}
</script>|
